import { render, staticRenderFns } from "./AddDialog.vue?vue&type=template&id=a00c8ac4&scoped=true&"
import script from "./AddDialog.vue?vue&type=script&lang=ts&"
export * from "./AddDialog.vue?vue&type=script&lang=ts&"
import style0 from "./AddDialog.vue?vue&type=style&index=0&id=a00c8ac4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a00c8ac4",
  null
  
)

export default component.exports